import { useEffect } from 'react'
import { KeycloakAdminService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import { AdminEnterName, useNVModal } from '@nv/components'
import { useSessionTimer } from '@nv/contexts'
import { useTranslation } from 'react-i18next'
import styles from './LogoutTimer.module.scss'

const LogoutTimer = ({ sessionTimeRemaining }) => {
  const { t } = useTranslation()
  const isTimeToExtend = !sessionTimeRemaining?.hours && sessionTimeRemaining?.minutes <= 4 && KeycloakAdminService.isLoggedIn()
  const { doExtendSession } = useSessionTimer()
  const { NVModal: EnterNameModal, openModal: openEnterNameModal, isModalOpen: isEnterNameModalOpen } = useNVModal()

  useEffect(() => {
    if (KeycloakAdminService?.isLoggedIn() && KeycloakAdminService.isContactInfoRoleAdmin() && !sessionStorage.getItem('name')) {
      openEnterNameModal()
    }
  }, [KeycloakAdminService?.isLoggedIn(), isEnterNameModalOpen])

  if (!sessionTimeRemaining) return null

  return (
    <>
      <EnterNameModal>
        <AdminEnterName />
      </EnterNameModal>
      <span className={styles['container']}>
        <span className={styles['title']}>
          {isTimeToExtend ? (
            <NVButton text={t('auth.admin.session.extend')} height={25} onClick={doExtendSession} />
          ) : (
            t('main.sessionTime')
          )}
        </span>

        <div className={styles['time']}>
          {sessionTimeRemaining.hours ? (
            <>
              <span className={styles['time__minutes-value']}>{sessionTimeRemaining.hours}</span>
              <span className={styles['time__minutes-label']} style={{ paddingRight: 5 }}>
                {t('countdown.time.short.hours')}
              </span>
            </>
          ) : null}
          <div className={isTimeToExtend ? styles['time__ending'] : ''}>
            <span className={styles['time__minutes-value']}>{sessionTimeRemaining.minutes}</span>
            <span className={styles['time__minutes-label']}>{t('countdown.time.short.mins')}</span>
            <span className={styles['time__seconds-value']}>{sessionTimeRemaining.seconds}</span>
            <span className={styles['time__seconds-label']}> {t('countdown.time.short.sec')}</span>
          </div>
        </div>
      </span>
    </>
  )
}

export default LogoutTimer
